//  For each product on the page
document.querySelectorAll('.product').forEach(section => {
    const product = JSON.parse(section.querySelector(".productJSON").textContent);
    let activeVariant = JSON.parse(section.querySelector(".activeVariantJSON").textContent);
    let quantity = 1;


    // during dev mode, set the active variant to the window so it can be accessed in the console
    if (Shopify.theme.role === "development") {
        window.product = product;
        window.activeVariant = activeVariant;
    }

    /************
     Product Swiper
     ************/

    const productSwiper = new Swiper(section.querySelector(".productVisualSwiper"), {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        autoHeight: true,
        // pagination: {
        //     el: section.querySelector('.swiper-pagination'),
        //     clickable: true,
        // },
        scrollbar: {
            el: section.querySelector(".swiper-scrollbar"),
            draggable: true,
        },
        on: {
            slideChange: function () {
                if (!section.querySelector(".productVisualSwiperSlide")) {
                    return;
                }

                // pause all videos
                section.querySelectorAll(".productVisualSwiperSlide video").forEach(element => {
                    element.pause();
                });
            }
        }
    });

    // play video on slide play click
    section.querySelectorAll(".productVisualSwiperSlide").forEach(element => {
        element.addEventListener("click", function () {
            // get video
            const video = this.closest(".productVisualSwiperSlide").querySelector("video");

            if (!video) {
                return;
            }

            // remove play button if it hasn't already been removed
            this.querySelector(".productVisualSwiperSlidePlay")?.remove();

            // show controls
            video.controls = true;

            // play video
            video.play();
        });
    });

    // update active variant on input changes
    section.querySelectorAll("input, select").forEach(function (element) {
        element.addEventListener("change", function () {
            updateProduct().catch(err => console.error(err));
        });
    })

    /**************
     Update Product
     ***************/

        // see if subscription box is active
    const subscriptionBox = document.querySelector('.productFormSelling');

    function isSubscription() {
        return !!document.querySelector(`.productFormSellingOptionHeaderInput[value="sub"]:checked`);
    }

    async function updateProduct() {
        // Find the active variant
        if (product.variants.length === 1) {
            // default fallback
            activeVariant = product.variants[0];
        } else {
            // collect options from inputs
            let options = [];
            section.querySelectorAll(`.productFormOptionsItem:not(.mobileOnly)`).forEach(group => {
                options.push(group.querySelector(`input:checked`).value);
            });

            // find new variant based on the options
            activeVariant = product.variants.find((variant) => {
                return JSON.stringify(variant.options) === JSON.stringify(options)
            });
        }

        // check if variant wasn't found
        if (!activeVariant) {
            section.querySelector(".productATC").disabled = true;
            section.querySelector(".productATC").textContent = "Not Available";
            return;
        }

        /**************
         Variant Image
         ***************/

        if (activeVariant.featured_image) {
            // change active slide
            productSwiper.slideTo(activeVariant.featured_image.position - 1);
        }

        /**************
         Price
         ***************/

            // if subscription turned off, skip
        const compare = section.querySelector(".productFormSellingOptionHeaderPriceCompare");
        const real = section.querySelector(".productFormSellingOptionHeaderPriceReal");
        const mainPrice = section.querySelector('.productPriceActual');
        const discountPrice = section.querySelector('.productPriceDiscount');
        if (subscriptionBox) {

            const allocationPrice = activeVariant.selling_plan_allocations[0].price;

            if (isSubscription()) {
                // Update with subscription prices
                if (activeVariant.price > allocationPrice) {
                    compare.textContent = price(activeVariant.price);
                    discountPrice.textContent = price(activeVariant.price);
                    discountPrice.style.display = "block";
                }
                real.textContent = price(allocationPrice);
                mainPrice.textContent = price(allocationPrice);
                compare.style.opacity = "1";
            } else {
                // Update with one-time purchase prices
                if (activeVariant.compare_at_price > activeVariant.price) {
                    compare.textContent = price(activeVariant.compare_at_price);
                    discountPrice.textContent = price(activeVariant.compare_at_price);
                    discountPrice.style.display = "block";
                }
                real.textContent = price(activeVariant.price);
                mainPrice.textContent = price(activeVariant.price);
                compare.style.opacity = "0";
                discountPrice.style.display = "none";
            }
        } else {
            mainPrice.textContent = price(activeVariant.price);
            discountPrice.textContent = activeVariant.compare_at_price > activeVariant.price ? price(activeVariant.compare_at_price) : "";
        }


        /**************
         ATC Enable/Disable
         ***************/

        // check if the variant is in stock
        if (activeVariant.available) {
            section.querySelector(".productATC").disabled = false;
            section.querySelector(".productATC").textContent = "Add To Cart";
        } else {
            section.querySelector(".productATC").disabled = true;
            section.querySelector(".productATC").textContent = "Sold Out";
        }

        // update url with variant id so the selected options are maintained on refresh
        let url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);
    }

    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    updateProduct().catch(err => console.error(err));

    /**************
     Product Quantity
     ***************/

    // minus
    section.querySelectorAll(".productQuantityControlsBtn.minus")?.forEach(el => el.addEventListener("click", function () {
        if (quantity === 1) {
            return;
        }
        quantity--;
        section.querySelectorAll(".productQuantityControlsValue").forEach(el => el.textContent = String(quantity));
        updateProduct().catch(err => console.error(err));
    }));

    // plus
    section.querySelectorAll(".productQuantityControlsBtn.plus")?.forEach(el => el.addEventListener("click", function () {
        quantity++;
        section.querySelectorAll(".productQuantityControlsValue").forEach(el => el.textContent = String(quantity));
        updateProduct().catch(err => console.error(err));
    }));


    /**************
     Product ATC
     ***************/

    async function addToCart() {

        // add loading animation to both buttons
        section.querySelector(".productATC").classList.add("loading");

        let formData = {
            items: [{
                quantity: quantity,
                id: activeVariant.id,
            }]
        };

        // check for selling plan
        if (isSubscription()) {
            formData.items[0].selling_plan = parseInt(section.querySelector('.productFormSellingOptionPlan').value)
        }

        // add product
        await addProduct(formData);

        // remove loading animation
        section.querySelector(".productATC").classList.remove("loading");

        // open cart
        // await openCart();
    }

    section.querySelector('.productATC').addEventListener("click", addToCart);

    // setup dropdowns
    section.querySelectorAll(".productDropdownsItemButton").forEach(element => {
        element.addEventListener("click", function () {
            this.classList.toggle("active");
        });
    });
});